import React from 'react'
import { Button, Input } from 'semantic-ui-react'
import db from '../../../utils/firebase'
import { toast } from 'react-toastify'

function ModificarEpisodio({episodio,serie}) {
    const [data,setData]=React.useState({
        video:""
    })

    const updateUrl = ()=>{
        if(data.video.length>10){
            
            db.collection("series").doc(serie.id).collection(episodio.temporada).doc(episodio.id).update({
                video:data.video
            }).then(()=>{
                toast.success("Actualizado")
            })
        }
    }


  return (
    <div>
      <div>
            <Input
                            placeholder="Actualizar Video"
                            onChange={(e) => setData({...data,video: e.target.value })}
                            className='inputAddBuscarSerie'
                            


            />
                    <Button className='botomAgregaarSerie' onClick={()=>updateUrl()}  >Actualizar Video</Button>

        </div>
    </div>
  )
}

export default ModificarEpisodio
